// extracted by mini-css-extract-plugin
export var grid = "fp-QR";
export var gridWithRowGap = "fp-RR";
export var maxWidthContainer = "fp-VR";
export var mt0 = "fp-IR";
export var mt1 = "fp-JR";
export var mt2 = "fp-KR";
export var mt3 = "fp-LR";
export var mt4 = "fp-MR";
export var mt5 = "fp-NR";
export var mt6 = "fp-OR";
export var navigationItems = "fp-WR";
export var navigationItems__body = "fp-XR";
export var navigationItems__logo = "fp-ZR";
export var navigationItems__logoLink = "fp-YR";
export var navigationItems__nav = "fp-_R";
export var navigationItems__nav__item = "fp-0R";
export var navigationItems__nav__list = "fp--R";
export var navigationItems__right = "fp-1R";
export var navigationItems__right__CTA = "fp-3R";
export var navigationItems__right__searchBtn = "fp-PR";
export var navigationItems__right__searchIcon = "fp-4R";
export var navigationItems__right__secondaryCTA = "fp-2R";
export var removeVisuallyHidden = "fp-TR";
export var visuallyHidden = "fp-SR";
export var widgetBase = "fp-UR";